import React from 'react';

import HelpButton from 'help/HelpButton';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';

import isParameterTypeEnabled from './data/isParameterTypeEnabled';
import {ParameterType} from './ParameterTypes';

interface ParameterTypeHelpButtonProps {
  className?: string;
}

export default function ParameterTypeHelpButton(props: ParameterTypeHelpButtonProps): JSX.Element {
  const typeHelpContent = (
    <div className="u-normal-font-weight">
      <p>
        The parameter's type controls which values it accepts and how those values are substituted into the
        SQL query.
      </p>
      <p>
        <strong>Text:</strong> Substituted as single-quoted text in SQL. <br />
        <b>value</b> becomes <code>'value'</code>
      </p>
      <p>
        <strong>Number:</strong> Substituted as number in SQL. <br />
        <b>3.14</b> becomes <code>3.14</code>
      </p>
      <p>
        <strong>Date:</strong> Substituted as date in SQL. <br />
        <b>2019-01-21</b> becomes <code>'2019-01-21'::date</code>
      </p>
      <p>
        <strong>Dropdown:</strong> The dropdown option name is substituted as single-quoted text in SQL.
        <br />
        <b>Kanamycin</b> becomes <code>'Kanamycin'</code>
      </p>
      <p>
        <strong>Entry:</strong> The entry ID is substituted as single-quoted text in SQL. <br />
        An entry with ID <b>etr_yzNP1XVd</b> becomes <code>'etr_yzNP1XVd'</code>
      </p>
      <p>
        <strong>Entity:</strong> The entity ID is substituted as single-quoted text in SQL. <br />A sequence
        with ID <b>seq_fcZi9llW</b> becomes <code>'seq_fcZi9llW'</code>
      </p>
      <p>
        <strong>Folder:</strong> The folder ID is substituted as single-quoted text in SQL. <br />A folder
        with ID <b>lib_ecYrmDJM</b> becomes <code>'lib_ecYrmDJM'</code>
      </p>
      <p>
        <strong>Project:</strong> The project ID is substituted as single-quoted text in SQL. <br />A project
        with ID <b>src_ztQi3aaR</b> becomes <code>'src_ztQi3aaR'</code>
      </p>
      {isParameterTypeEnabled(ParameterType.STORABLE_LINK) && (
        <p>
          <strong>Inventory:</strong> The inventory item ID is substituted as a single-quoted text in SQL.
          <br />A container with ID <b>con_8Gp0Zxh2</b> becomes <code>'con_8Gp0Zxh2'</code>
        </p>
      )}
      <p>
        <strong>Study:</strong> The study ID is substituted as a single-quoted text in SQL. <br />A study with
        ID <b>stdy_y1afX3Fv</b> becomes <code>'stdy_y1afX3Fv'</code>
      </p>
      <p>
        <strong>Team:</strong> The team ID is substituted as a single-quoted text in SQL. <br />A team with ID{' '}
        <b>ent_y1afX3Fv</b> becomes <code>'ent_y1afX3Fv'</code>
      </p>
      <p>
        <strong>User:</strong> The user ID is substituted as a single-quoted text in SQL. <br />A user with ID{' '}
        <b>ent_y1afX3Fv</b> becomes <code>'ent_y1afX3Fv'</code>
      </p>
      <p>
        <strong>Workflow task group:</strong> The workflow task group ID is substituted as single-quoted text
        in SQL. <br />A workflow task group with ID <b>prs_Fea8JY5U</b> becomes <code>'prs_Fea8JY5U'</code>
      </p>
      <p>
        <strong>Workflow task:</strong> The workflow task ID is substituted as single-quoted text in SQL.{' '}
        <br />A workflow with ID <b>wftask_fj7Usr5H</b> becomes <code>'wftask_fj7Usr5H'</code>
      </p>
    </div>
  );

  return (
    <HelpButton
      renderContent={() => typeHelpContent}
      iconClassName={props.className}
      placement={FloatingPlacement.BOTTOM}
    />
  );
}
